import { SessionUser } from '@generated-types';

import { isOver18FromBirthDate } from './date-utils';

export const isOver18 = ({ birthDate }: SessionUser) => isOver18FromBirthDate(birthDate);
